import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes garbage collection
      // Een 400 of 403 is een geweigerd verzoek: opnieuw proberen geeft hetzelfde antwoord en houdt de
      // melding alleen langer weg. Een storing (5xx, netwerk) krijgt één herpoging.
      retry: (failureCount, error) =>
        failureCount < 1 && !(isAxiosError(error) && (error.response?.status === 400 || error.response?.status === 403)),
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
